import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
export const CardWraper = ({ children, mt, background = 'white' }) => {
    return _jsx(Box, { sx: {
            background: background,
            position: 'relative',
            mt: mt || 0,
            backgroundColor: '#00244D0A',
            borderRadius: 1,
            px: { xs: 1.5, lg: 2.5 },
            py: 2,
            border: '1px solid #00244D33',
            height: '100%'
        }, children: children });
};
